// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://devmavalue.plataforma-smart.com',
  //apiUrl: 'https://ndbx.multiasistencia.garajedeideas.es',
  apiGoogle: 'AIzaSyBGcJzGwjFepFIt0TTlunYgpcwCzV98fwQ', //ONLY FOR LOCAL TESTING, CHANGE BEFORE DEPLOY
  s3Url: 'https://devmavalue.plataforma-smart.com/staticontents/assets',

  //s3Url: 'https://garaje-de-ideas-multiasistencia-dev-i9demy4g.s3.eu-west-1.amazonaws.com/assets'
  apiBillma: 'https://pre2-billma.plataforma-smart.com',
  redirectUri: 'https://devmavaluendbx.plataforma-smart.com/login',
  adobeUrl: 'https://assets.adobedtm.com/dd4adce84cad/23557c1a8408/launch-e173f7a3916d.min.js',
  cognitoUrl: 'https://eu-west-3tw1e5gor8.auth.eu-west-3.amazoncognito.com',
  cognitoClientId: '5ohh5ssg1rpjk0ebk75omlkl6i'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI
